import { SnapButton, SnapIcon } from "suit";

type BeneficialOwnersButtonsProps = {
  onAddOwner?: () => void;
  onRemoveOwner?: () => void;
};

export const BeneficialOwnersButtons = ({
  onAddOwner,
  onRemoveOwner,
}: BeneficialOwnersButtonsProps) => (
  <div className="flex mt-2 justify-end gap-2">
    {onRemoveOwner && (
      <SnapButton variant="danger" onClick={onRemoveOwner}>
        Remove Owner <SnapIcon icon="minus-solid" color="#FFF" size="sm" />
      </SnapButton>
    )}
    {onAddOwner && (
      <SnapButton variant="tertiary" onClick={onAddOwner}>
        Add Owner <SnapIcon icon="plus-solid" color="#2563EB" size="sm" />
      </SnapButton>
    )}
  </div>
);
